import { PaginatedQueryResult } from '@query/usePaginatedQuery'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'

import {
  SensitiveTableCell,
  Table,
  TableBody,
  TableCell,
  TableHeadSort,
  TableHeader,
  TableRow,
} from '@ui/v2/Table/Table'

import { PageQuery } from '@utils/ApiClient'
import { getCentralRowIdConditionally } from '@utils/getItemId'

import { ClientIbContestCampaignResultDto } from '@model/ClientIbContestCampaignResultDto'

interface Props {
  tableQuery: PaginatedQueryResult<ClientIbContestCampaignResultDto>
  pageQuery?: PageQuery
  setPageQuery: (pageQuery: PageQuery) => void
}

export const IBContestResultsTable: React.FC<Props> = (props) => {
  const { tableQuery, pageQuery, setPageQuery } = props
  const { isLoading, data } = tableQuery
  const { t } = useTranslation()
  const { account } = useAccountReadContext()

  return (
    <Table isLoading={isLoading} noResults={!data.length}>
      <TableHeader>
        <TableRow>
          <TableHeadSort
            id='Rank'
            sort={pageQuery?.sort || undefined}
            sortOrder={pageQuery?.sortOrder}
            setSort={(sort, sortOrder) =>
              setPageQuery?.({
                ...pageQuery,
                sort,
                sortOrder,
              })
            }
          >
            {t('IB.Ranking')}
          </TableHeadSort>
          <TableHeadSort
            id='IntroducingBroker.Name'
            sort={pageQuery?.sort || undefined}
            sortOrder={pageQuery?.sortOrder}
            setSort={(sort, sortOrder) =>
              setPageQuery?.({
                ...pageQuery,
                sort,
                sortOrder,
              })
            }
          >
            {t('IB.IB Username')}
          </TableHeadSort>
          <TableHeadSort
            id='ClientCount'
            sort={pageQuery?.sort || undefined}
            sortOrder={pageQuery?.sortOrder}
            setSort={(sort, sortOrder) =>
              setPageQuery?.({
                ...pageQuery,
                sort,
                sortOrder,
              })
            }
          >
            {t('IB.Number of Clients')}
          </TableHeadSort>
          <TableHeadSort
            id='ContestPoints'
            sort={pageQuery?.sort || undefined}
            sortOrder={pageQuery?.sortOrder}
            setSort={(sort, sortOrder) =>
              setPageQuery?.({
                ...pageQuery,
                sort,
                sortOrder,
              })
            }
          >
            {t('IB.Contest Points')}
          </TableHeadSort>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((x, index) => {
          const rowProps = getCentralRowIdConditionally(index, data.length, 'ib-contest-results')
          const isSelected = account?.clientIntroducingBroker?.name === x.ibCode
          return (
            <TableRow key={x.ibCode} {...rowProps} {...(isSelected && { selected: true })}>
              <TableCell>#{x.ranking}</TableCell>
              <SensitiveTableCell>{x.ibCode}</SensitiveTableCell>
              <SensitiveTableCell>{x.numberOfClients}</SensitiveTableCell>
              <SensitiveTableCell>{x.points}</SensitiveTableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
